import { render } from "./SpmButton.vue?vue&type=template&id=b44db7aa"
import script from "./SpmButton.vue?vue&type=script&lang=ts"
export * from "./SpmButton.vue?vue&type=script&lang=ts"

import "./SpmButton.vue?vue&type=style&index=0&id=b44db7aa&lang=scss"
script.render = render

export default script